import React from 'react';

interface ButtonProps {
  variant: 'primary' | 'outline';
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ 
  variant, 
  children, 
  onClick, 
  type = 'button', 
  disabled = false,
  className = '' 
}) => {
  const baseClasses = "px-8 py-4 rounded-full w-full font-medium text-base transition-all duration-200 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed";
  const variantClasses = {
    primary: "text-white shadow-lg hover:shadow-xl",
    outline: "border-2 shadow-md hover:shadow-lg"
  };
  
  const primaryStyle = variant === 'primary' ? { 
    backgroundColor: '#002457',
    borderColor: '#002457'
  } : {
    borderColor: '#002457',
    color: '#002457',
    backgroundColor: 'transparent'
  };
  
  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      style={primaryStyle}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = '#41EFAA';
          e.currentTarget.style.color = '#002457';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          if (variant === 'primary') {
            e.currentTarget.style.backgroundColor = '#002457';
            e.currentTarget.style.color = 'white';
          } else {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#002457';
          }
        }
      }}
    >
      {children}
    </button>
  );
};

export default Button;
